import type { ReactNode } from 'react'

export type StampProps = {
  children: ReactNode
  color?: string
  rotate?: number
  size?: number
}

export const Stamp = ({ children, color = 'var(--terra)', rotate = -3, size = 13 }: StampProps) => (
  <span
    style={{
      display: 'inline-block',
      transform: `rotate(${rotate}deg)`,
      border: `2px solid ${color}`,
      color,
      fontFamily: 'var(--font-display)',
      fontWeight: 700,
      fontSize: size,
      letterSpacing: 0.6,
      textTransform: 'uppercase',
      padding: '3px 8px',
      borderRadius: 3,
      background: 'rgba(255,255,250,0.5)',
    }}
  >
    {children}
  </span>
)
